var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("col-12 text-muted text-" + _vm.align)},[_c('small',[_vm._v(_vm._s(_vm.content || _vm.$t('content')))]),_c('h4',{staticClass:"mt-2"},[_vm._v("¯\\_(ツ)_/¯")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }